import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';


import SelectionDropdown from '../../Common/SelectionDropdown';
import { FULL_TEST_TYPES, TEST_CREATE_TYPE_BASIC, securedCreateTest, securedCreateTestSeries, securedCreateTestUsers, securedDeleteTestUsers, securedFetchAllTestSeries, securedUpdateTest } from '../../../services/TestService';
import { UnauthorizedError } from '../../../services/Errors';
import { ADMIN_USER_TYPE, securedFetchUsers } from '../../../services/UserService';
import { navigateCallbackOptions } from '../../../services/AuthenticationService';

import { AiFillCloseCircle, AiFillDelete, AiFillPlusCircle } from "react-icons/ai";
import { checkArraysEqual, getUniqueValues, updateArray } from '../../../services/CommonService';
import { QUESTION_FILTER_SUBTYPES, QUESTION_UPLOAD_TYPES } from '../../../services/QuestionService';

const AutoTestSectionData = ({ sectionsData, setSectionsData, subjects, selectedSubjects, selectedMainTopics, selectedTopics }) => {

    const [allowedSubjects, setAllowedSubjects] = useState([]);
    const { t } = useTranslation();

    useEffect(() => {
        const includedSubjectIds = getIncludedSubjectIds();
        setAllowedSubjects(subjects.filter(subject => includedSubjectIds.includes(subject.id)));
    }, [subjects, selectedSubjects, selectedMainTopics, selectedTopics]);

    const getIncludedSubjectIds = () => {
        if (selectedSubjects.length === 0 && selectedTopics.length === 0 && selectedMainTopics.length === 0) {
            return subjects.map(subject => subject.id);
        }
        if (selectedTopics.length > 0 || selectedMainTopics.length > 0) {
            return [...selectedTopics, ...selectedMainTopics].map(topic => topic.subject_id);
        }
        return selectedSubjects.map(subject => subject.id);
    }

    const onAddSectionData = (e) => {
        e.preventDefault();
        const newSubject = sectionsData.length > 0 ? sectionsData[sectionsData.length - 1].subject : allowedSubjects[0];
        setSectionsData(prevSectionsData => [...prevSectionsData, { type: QUESTION_UPLOAD_TYPES[0], sub_type: QUESTION_FILTER_SUBTYPES[0], number_of_questions: 0, subject: newSubject, full_marks: 0, negative_marks: 0, partial_marks: 0 }])
    }

    const onDeleteSectionData = (e, index) => {
        e.preventDefault();
        setSectionsData(prevSectionsData => [...prevSectionsData.slice(0, index), ...prevSectionsData.slice(index + 1, prevSectionsData.length)]);
    }

    const onSelectedTypeChange = (selection, index) => {
        const currentData = sectionsData[index];
        setSectionsData(prevSectionsData => updateArray(prevSectionsData, index, { ...currentData, type: { id: selection.value, name: selection.label } }));
    }

    const onSelectedSubTypeChange = (selection, index) => {
        const currentData = sectionsData[index];
        setSectionsData(prevSectionsData => updateArray(prevSectionsData, index, { ...currentData, sub_type: { id: selection.value, name: selection.label } }));
    }

    const onSelectedSubjectChange = (selection, index) => {
        const currentData = sectionsData[index];
        setSectionsData(prevSectionsData => updateArray(prevSectionsData, index, { ...currentData, subject: allowedSubjects.find(subject => subject.id === selection.value) }));
    }

    const onTextChange = (value, fieldName, index) => {
        const currentData = sectionsData[index];
        currentData[fieldName] = value;
        setSectionsData(prevSectionsData => updateArray(prevSectionsData, index, currentData));
    }

    return (<>
        {sectionsData.map((data, index) => {
            return (
                <div key={index} className="autoTestSectionCreate">
                    <h>Section {index + 1}</h>
                    <SelectionDropdown className="testSelectionDropdown" name="Subject" itemList={allowedSubjects} selectedItem={data.subject} onSelectionChange={(selection) => onSelectedSubjectChange(selection, index)} nameField='subject_name' valueField='id' />
                    <div className="testInfoInput flex">
                        <label className="title">Number of Questions </label>
                        <input type="text" className="text" value={data.number_of_questions} onChange={(e) => onTextChange(e.target.value, 'number_of_questions', index)} placeholder="Number of Questions" />
                    </div>

                    <SelectionDropdown className="testSelectionDropdown" name="Question Type" itemList={QUESTION_UPLOAD_TYPES} selectedItem={data.type} onSelectionChange={(selection) => onSelectedTypeChange(selection, index)} nameField='name' valueField='id' />
                    {data.type && data.type.id === 'paragraph' && (
                        <SelectionDropdown className="testSelectionDropdown" name="Question Sub-Type" itemList={QUESTION_FILTER_SUBTYPES} selectedItem={data.sub_type} onSelectionChange={(selection) => onSelectedSubTypeChange(selection, index)} nameField='name' valueField='id' />)}
                    <div className="testSectionNumbers flex">
                        <label className="numbersTitle">Marks per Question:</label>
                        <div className="numbersInput flex">
                            <label htmlFor="fullMarks">Full Marks</label>
                            <input
                                type="number"
                                id="fullMarks"
                                className="testMarks"
                                value={data.full_marks}
                                onChange={(e) =>
                                    onTextChange(e.target.value < 0 ? 0 : e.target.value, 'full_marks', index)
                                }
                            />
                        </div>

                        <div className="numbersInput flex">
                            <label htmlFor="negativeMarks">Negative Marks</label>
                            <input
                                type="number"
                                id="negativeMarks"
                                className="testMarks"
                                value={data.negative_marks}
                                onChange={(e) =>
                                    onTextChange(e.target.value > 0 ? 0 : e.target.value, 'negative_marks', index)
                                }
                            />
                        </div>

                        <div className="numbersInput flex">
                            <label htmlFor="partialMarks">Partial Marks</label>
                            <input
                                type="number"
                                id="partialMarks"
                                className="testMarks"
                                value={data.partial_marks}
                                onChange={(e) =>
                                    onTextChange(e.target.value < 0 ? 0 : e.target.value, 'partial_marks', index)
                                }
                                max={data.full_marks / 3}
                            />
                        </div>
                    </div>
                    <button className='btn flex' onClick={(e) => onDeleteSectionData(e, index)}>
                        {'Delete Section'} <AiFillDelete className="icon" />
                    </button>
                </div>
            );
        })}
        <button className='btn flex' onClick={(e) => onAddSectionData(e)}>
            {'Add Section'} <AiFillPlusCircle className="icon" />
        </button>
    </>)
}

export default AutoTestSectionData;
